module.exports = __webpack_public_path__ + "media/mypage/images/no-icon-9344f89011f5c61b1d7a1fc5e0ead24e.png";